import { BaseCollection } from './BaseCollection';

export class TopicCollection extends BaseCollection {
    constructor() {
        super();
        this.TOPIC_NEXT_DISPLAY_PAGE = {};
        this.TOPIC_REACHED_END = {};
        this.notifications = [];
    }

    loadTopicPage(topic, loadMore, page) {
        return super.loadData(topic.topic, page).then(({ list, next, reachedEnd }) => {
            if (!list) {
                return { data: [], reachedEnd, topic };
            }

            if (!this.TOPIC_NEXT_DISPLAY_PAGE[topic.topic] || loadMore && !reachedEnd && next) {
                this.TOPIC_NEXT_DISPLAY_PAGE[topic.topic] = next;
            }

            const filteredData = super.filterData(list);

            if (reachedEnd || !filteredData.length || !next || next === 'false') {
                this.TOPIC_REACHED_END[topic.topic] = true;
            }

            return { data: filteredData, reachedEnd, topic };
        });
    }

    fetch(loadMore) {
        this.perTopicNotifications = {};
        const promises = [];
        if (!loadMore) {
            this.notifications = [];
        }

        this.topics.forEach((topic) => {
            if (!this.TOPIC_REACHED_END[topic.topic] || !loadMore) {
                promises.push(
                    this.loadTopicPage(
                        topic,
                        loadMore,
                        (loadMore ? this.TOPIC_NEXT_DISPLAY_PAGE[topic.topic] : 'latest.json')
                    )
                    .then((notif) => {
                        this.notifications = this.notifications.concat(notif.data);
                        return notif;
                    })
                );
            }
        });

        return Promise.all(promises).then((vals) => {
            const reachedEnd = vals.every(i => i.reachedEnd);
            const deduped = super.dedupeData(this.notifications);

            if (deduped.length >= this.MINIMUM_TO_DISPLAY || reachedEnd) {
                return { data: deduped, reachedEnd };
            }

            return this.fetch(true);
        });
    }
}



/** WEBPACK FOOTER **
 ** ./assets/js/models/collections/TopicCollection.js
 **/